import React from 'react';
import BaseLayout from './src/layouts/base';

import './src/scss/index.scss';

export const wrapPageElement = ({ element, props }) => {
	return <BaseLayout {...props}>{element}</BaseLayout>;
};
